import React from 'react';
import { BookIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { checkoutUrl, offer } from '../data/content';
interface FinalCtaProps {
  showUrgency?: boolean;
}
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="w-full bg-blue-50 py-16 md:py-24" data-id="element-84" data-mp="15c2dz80bslrd">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-85" data-mp="1jcd6efhaa8en">
        {showUrgency && <CountdownPanel showScarcity={false} data-id="element-86" data-mp="1eeblrq47m112" />}

        <div className="mx-auto mt-12 max-w-lg rounded-2xl bg-white p-8 text-center shadow-lift ring-2 ring-gold-400" data-id="element-87" data-mp="1ediodfr54nvl">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-blue-900 text-gold-300" data-id="element-88" data-mp="1t50zaz557s83">
            <BookIcon className="h-6 w-6" aria-hidden="true" data-id="element-89" data-mp="223mhgt6pd58c" />
          </span>
          <h3 className="mt-5 font-display text-xl font-extrabold uppercase leading-snug tracking-tight text-ink" data-id="element-90" data-mp="221jtsft0vo6s">
            {offer.name}
          </h3>
          <p className="mt-2 text-blue-900/70" data-id="element-91" data-mp="n6nul8d98n1j">6 Tomos + 6 Bonos, listos para usar hoy</p>
          <p className="mt-7" data-id="element-92" data-mp="s3w2mg4ovap2">
            <span className="block text-base text-blue-900/45 line-through" data-id="element-93" data-mp="s57fr6k0xusu">
              {offer.listPrice} ARS
            </span>
            <span className="font-display text-4xl font-extrabold tracking-tight text-ink md:text-5xl" data-id="element-94" data-mp="x64v7bdngaqn">
              {offer.price}
              <span className="ml-2 text-lg font-semibold text-blue-900/55" data-id="element-95" data-mp="1658iysnrhebh">ARS</span>
            </span>
          </p>
          <div className="mt-8" data-id="element-96" data-mp="1b28on2gp8f22">
            <CtaButton size="lg" className="w-full" href={checkoutUrl} data-id="element-97" data-mp="1b1gpxirt217k">
              Empezar mi BIO-RESET hoy
            </CtaButton>
          </div>
        </div>

        <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-98" data-mp="1ks1nd2vqszow">
          <li className="inline-flex items-center gap-2" data-id="element-99" data-mp="1puagbz8m81r0">
            <ZapIcon className="h-4 w-4 text-gold-600" aria-hidden="true" data-id="element-100" data-mp="1tt9ijc2ypker" /> Acceso inmediato
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-101" data-mp="3qvqirsxrayku">
            <ShieldCheckIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-102" data-mp="3lvkqcajnx81p" /> Garantía 7 días
          </li>
        </ul>
      </div>
    </section>;
}